import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setToken } from "@/utils";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { INIT_ROUTES } from "@/router";

const OAuthCallbackPage: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [settled, setSettled] = useState<boolean>(false);
  const redirectUrl = useAppSelector((state) => state.loginRedirect.redirectUrl);

  useEffect(() => {
    const token = location.hash.split("access_token=")[1]?.split("&")[0];

    if (token) {
      setToken.forAll(dispatch, token);
    }
    setSettled(true);
  }, [dispatch, location.hash]);

  if (settled) {
    return <Navigate to={redirectUrl || INIT_ROUTES.initApp.path} />;
  }
  return null;
};

export default OAuthCallbackPage;
